import getMinBuyForQuantityDropdown from "./AddToCart/getMinBuyForQuantityDropdown";

export default (
  minBuy: number,
  mustBuy: number,
  unitOfMeasure: string,
  isGoogleView?: boolean,
): string => {
  const pricePerPoundUom =
    unitOfMeasure === "lb" ? ` ${unitOfMeasure.toLowerCase()}s` : "";

  let updatedMinBuy = minBuy;

  if (minBuy > 1) {
    updatedMinBuy = getMinBuyForQuantityDropdown({ minBuy, mustBuy });
  }

  if (isGoogleView) {
    if (updatedMinBuy > 1 && mustBuy > 1) {
      return `The price displayed is for a minimum purchase of ${updatedMinBuy}${pricePerPoundUom} at a time due to manufacturer packaging.`;
    }

    if (mustBuy > 1) {
      return `The price displayed is for a minimum purchase of ${mustBuy}${pricePerPoundUom} at a time due to manufacturer packaging.`;
    }

    if (updatedMinBuy > 1) {
      return `The price displayed is for a minimum purchase of ${updatedMinBuy} units.`;
    }
  } else {
    if (updatedMinBuy > 1 && mustBuy > 1) {
      return `You must buy a minimum of ${updatedMinBuy}${pricePerPoundUom} and in additional increments of ${mustBuy}${pricePerPoundUom} due to manufacturer packaging.`;
    }

    if (mustBuy > 1) {
      return `You must buy a minimum of ${mustBuy}${pricePerPoundUom} at a time due to manufacturer packaging.`;
    }

    if (updatedMinBuy > 1) {
      return `You must buy a minimum of ${updatedMinBuy}${pricePerPoundUom} due to manufacturer packaging.`;
    }
  }

  return "";
};
